import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
export function CTASection() {
  const gclid = useGclid();
  const href = buildShopUrl(SHOP_URL, gclid);
  return <section className="max-w-3xl mx-auto px-6 py-16 text-center" data-id="element-12">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-brand-lightAmber rounded-2xl p-8 sm:p-12 border border-brand-amber/20 shadow-lg" data-id="element-13">
        <h2 className="text-3xl sm:text-4xl font-bold text-brand-brown mb-4" data-id="element-14">
          Hilf auch deinem Hund – natürlich & sanft
        </h2>
        <p className="text-lg text-stone-700 font-serif mb-8 max-w-xl mx-auto" data-id="element-15">
          Teste das Magen-Darm-Topping jetzt risikofrei – mit
          Geld-zurück-Garantie. Wenn es deinem Hund nicht hilft, bekommst du
          dein Geld zurück.
        </p>

        <p className="text-sm font-sans text-stone-600 mb-6 flex items-center justify-center gap-1.5" data-id="element-16">
          <span className="text-brand-amber" data-id="element-17">★★★★☆</span>
          <span data-id="element-18">4,4/5 · 876 Hundehalter haben es bewertet</span>
        </p>

        <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={() => trackCTAClick('Jetzt für meinen Hund bestellen', 'bottom_cta')} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full sm:w-auto bg-brand-amber hover:bg-brand-amber/90 text-white font-sans font-bold text-lg py-4 px-8 rounded-full shadow-md transition-colors flex items-center justify-center gap-2 mx-auto inline-block no-underline" data-id="element-19">
          Jetzt für meinen Hund bestellen
          <ArrowRight className="w-5 h-5" data-id="element-20" />
        </motion.a>

        <p className="mt-4 text-xs text-stone-500 font-sans" data-id="element-21">
          Sichere Bezahlung • Kostenloser Versand ab 39€
        </p>

        <div className="mt-6 pt-6 border-t border-brand-amber/20" data-id="element-22">
          <p className="text-sm text-stone-500 font-sans max-w-md mx-auto" data-id="element-23">
            💡 Tipp: Viele Kunden nutzen auch den Sparplan und sichern sich so
            Rabatte – so habe ich es auch getan.
          </p>
        </div>
      </motion.div>
    </section>;
}